import Icon from "./Icon";
import library from "./library";


export { library };
export default Icon;
